import {
    useState,
    useEffect,
    createRef
} from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Grid, Sticky } from 'semantic-ui-react';
import { useParams, useSearchParams } from "react-router-dom";
import LabGuide from "../components/LabGuide";
import { useLabContext } from "../LabContext";
import ErrorMessage from "../components/ErrorMessage";
import LabSegment from "../components/LabSegment";
import LabProgress from "../components/LabProgress";
import TableOfContents from "../components/TableOfContents";
import i18n from "../i18n";
import { Typography } from "@okta/odyssey-react-mui";
import Loader from "../components/Loader";
import flagsmith from "flagsmith";
import { useFlags, useFlagsmithLoading } from "flagsmith/react";

const Preview = () => {
    let params = useParams();
    const flags = useFlags(['arches_lab_mapping', 'arches_mode']);
    const [searchParams] = useSearchParams();
    const [lab, setLab] = useState()
    const [labStep, setLabStep] = useState(0)
    const [error, setError] = useState(null)
    const { isAuthenticated } = useAuth0();
    const labContext = useLabContext();
    const [matches, setMatches] = useState(
        window.matchMedia("(min-width: 768px)").matches
    )

    const flagsmithState = useFlagsmithLoading();
    const [connection, setConnection] = useState()

    useEffect(() => {
        if (!flagsmithState.isLoading && !flagsmithState.isFetching) {
            setConnection(flagsmith.getTrait("connection"))
        }
    }, [flagsmithState])

    useEffect(() => {
        window
            .matchMedia("(min-width: 768px)")
            .addEventListener('change', e => setMatches(e.matches));
    }, []);

    const docRef = createRef()

    useEffect(() => {
        setError(null)
        if (isAuthenticated) {
            if(connection !== 'employee') {
                setError('You must be an employee to preview lab content');
                return;
            }
            const assetId = params.content
            // TODO: Remove once on arches
            let labId = assetId;
            if(flags.arches_mode.enabled) {
                const reversedMapping = Object.fromEntries(
                    Object
                        .entries(
                            JSON.parse(flags.arches_lab_mapping.value)
                        )
                        .map(([key, value]) => [value, key])
                    )
                labId = reversedMapping[labId] || assetId;
            }
            if (labId) {
                const resolvedLab = labContext.labs.find(lab => lab.id === labId);
                if(!resolvedLab) {
                    setError('Lab not found');
                    return;
                }
                setLab(resolvedLab);
            }
            else{
                setError('Required a labId query parameter to be set');
            }
        }
    }, [isAuthenticated, params.content, labContext.labs, lab, connection, flags.arches_lab_mapping, flags.arches_mode])

    function advanceStep() {
        const navigatedStep = labStep + 1;
        if (navigatedStep !== lab.steps.length) {
            setLabStep(navigatedStep)
            window.scrollTo(0, 0)
        }
    }

    function regressStep() {
        const navigatedStep = labStep - 1;
        if (navigatedStep >= 0) {
            setLabStep(navigatedStep)
            window.scrollTo(0, 0)
        }
    }

    function setStep(step) {
        setLabStep(step)
        window.scrollTo(0, 0)
    }

    return (
        <>
            {error ? (<ErrorMessage error={error} />) : null}
            { lab ?
                searchParams.has('LaunchPanel') ?
                    (
                        <LabSegment lab={lab} demo={undefined} idp={undefined} labStep={labStep} />
                    ) :
                        <Grid stackable columns={3}>
                            <Grid.Column width={3}>
                                <Sticky context={docRef} active={true}>
                                    <TableOfContents lab={lab} currentStep={labStep} setStep={setStep} collapse={!matches}></TableOfContents>
                                    {!matches && <LabSegment lab={lab} demo={undefined} idp={undefined} labStep={labStep} collapse={!matches} />}
                                </Sticky>
                            </Grid.Column>
                            <Grid.Column width={10}>
                                <Typography variant="h1">{typeof lab.steps[labStep]?.step === 'string' ? lab.steps[labStep]?.step : (lab.steps[labStep]?.step[i18n.language]?lab.steps[labStep]?.step[i18n.language]:lab.steps[labStep]?.step['en'])}</Typography>
                                <LabGuide contentLink={lab.steps[labStep]?.guide} documentRef={docRef} variableData={{ idp: undefined, demo: undefined }} />
                                <LabProgress lab={lab} labStep={labStep} function_advance={advanceStep} function_regress={regressStep} />
                            </Grid.Column>
                            <Grid.Column width={3}>
                                <Sticky context={docRef} active={true}>
                                    {matches && <LabSegment lab={lab} demo={undefined} idp={undefined} labStep={labStep} />}
                                </Sticky>
                            </Grid.Column>
                        </Grid>
                     : (
                        <Loader/>
                )}
        </>
    )
}
export default Preview;